import { getChannelByUrl } from '../config';

export const useIsOkta = (): boolean => {
    const salesChannelConfig = getChannelByUrl(window.location.host);
    const isOkta = salesChannelConfig?.sso === 'okta';

    return Boolean(isOkta);
};
